import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonInput from "../../../components/forms/CommonInput";
import { handleChange } from "../../../helpers/handleFormChanges";
import PropTypes from "prop-types";
import CommonInputSenha from "../../../components/forms/CommonInputSenha";

function NovoUsuarioModal({ modalHook, valuesHook, criarUsuario }) {
  const { values, setValues } = valuesHook;
  const { novoUsuarioModal, setNovoUsuarioModal } = modalHook;

  const gerarSenha = () => {
    const lowercase = "abcdefghijklmnopqrstuvwxyz";
    const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const numbers = "0123456789";
    const special = "!@#$%^&*()_+-=[]{}|;:,.<>?";
    const allChars = lowercase + uppercase + numbers + special;

    const getRandomChar = (str) => str[Math.floor(Math.random() * str.length)];

    let password = [
      getRandomChar(lowercase),
      getRandomChar(uppercase),
      getRandomChar(numbers),
      getRandomChar(special),
    ];

    for (let i = password.length; i < 10; i++) {
      password.push(getRandomChar(allChars));
    }

    for (let i = password.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [password[i], password[j]] = [password[j], password[i]];
    }

    setValues((prevValues) => ({
      ...prevValues,
      senha: password.join(""),
      confirme_senha: password.join(""),
    }));
  };

  return (
    <CommonModal
      title="Novo usuário"
      is_open_modal={novoUsuarioModal}
      set_is_open_modal={setNovoUsuarioModal}
      size="lg"
      buttons={
        <>
          <CommonButton key={`gerar-senha`} color="info" onClick={gerarSenha}>
            Gerar senha
          </CommonButton>
          <CommonButton
            key={`novo-usuario`}
            color="success"
            onClick={criarUsuario}
          >
            Salvar
          </CommonButton>
        </>
      }
    >
      <div className="row">
        <div className="col-lg-6 mb-3">
          <CommonInput
            label="E-mail"
            id="email"
            type="email"
            value={values.email}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
        <div className="col-lg-6 mb-3">
          <CommonInput
            label="Usuário"
            id="usuario"
            value={values.usuario}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 mb-3">
          <CommonInputSenha
            label="Senha"
            id="senha"
            value={values.senha}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
        <div className="col-lg-6 mb-3">
          <CommonInputSenha
            label="Confirme a senha"
            id="confirme_senha"
            value={values.confirme_senha}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
      </div>
    </CommonModal>
  );
}

NovoUsuarioModal.propTypes = {
  modalHook: PropTypes.shape({
    novoUsuarioModal: PropTypes.bool.isRequired,
    setNovoUsuarioModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  criarUsuario: PropTypes.func.isRequired,
};

export default NovoUsuarioModal;
